import Rotate from './RotateFeature'
import DrawRectangle from './DrawRectangle'
import Resize from './Resize'

function init( options ) {
  return {
    draw_rectangle : DrawRectangle.init( options ),
    rotate : Rotate.init( options ),
    resize : Resize.init( options )
  }
}

module.exports = {
  Rotate,
  DrawRectangle,
  Resize,
  init
}
